import { render, staticRenderFns } from "./CardTesteVencendo.vue?vue&type=template&id=581d3eb6&scoped=true&"
import script from "./CardTesteVencendo.vue?vue&type=script&lang=js&"
export * from "./CardTesteVencendo.vue?vue&type=script&lang=js&"
import style0 from "./CardTesteVencendo.vue?vue&type=style&index=0&id=581d3eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581d3eb6",
  null
  
)

export default component.exports